import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './generic-toggle-switch.component.html',
  styleUrls: ['./generic-toggle-switch.component.scss']
})
export class ToggleSwitchComponent {
  @Input() public activated = false;
}
